import React from 'react';
import { Group } from '../../../../../../redux/groups/api/group.model';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import GroupContactAction from './GroupContactAction';
import GroupHistoryAction from './GroupHistoryAction';
import GroupRecipesAction from './GroupRecipesAction';
import GroupCamerasAction from './GroupCamerasAction';
import { DefaultMenuButtons } from '../../../../../../theme/components';
import GroupSettingsAction from './GroupSettingsAction';
import GroupAlarmsAction from './GroupAlarmsAction';
import GroupComposableDeviceAction from './GroupComposableDeviceAction';
import { GroupComposableDashboardAction } from './GroupComposableDashboardAction';
import GroupDashboardAction from './GroupDashboardAction';
import GroupReportAction from './GroupReportAction';

export interface GroupActionsProps {
  group?: Group;
  variant?: 'icon' | 'menuItem';
}
export function GroupActionsList(props: GroupActionsProps) {
  const { group } = props;
  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        alignContent: 'center',
        justifyContent: 'flex-end',
        fontSize: '1.8em',
        gap: '1.2em',
        color: (theme) => theme.typography.body1.color,
      })}
    >
      <GroupDashboardAction group={group} />
      <GroupContactAction group={group} />
      <GroupSettingsAction group={group} />
      <GroupHistoryAction group={group} />
      <GroupRecipesAction group={group} />
      <GroupCamerasAction group={group} />
      <GroupComposableDeviceAction group={group} />
      <GroupComposableDashboardAction group={group} />
      <GroupReportAction group={group} />
      <GroupAlarmsAction group={group} />
    </Box>
  );
}

export function GroupActionsGrid(props: GroupActionsProps) {
  const { group } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const variant = isMobile ? 'menuItem' : 'icon';

  const menuButtons = [
    <GroupDashboardAction
      key="GroupDashboardAction"
      variant={variant}
      group={group}
    />,
    <GroupContactAction
      key="GroupContactAction"
      variant={variant}
      group={group}
    />,
    <GroupSettingsAction
      key="GroupSettingsAction"
      variant={variant}
      group={group}
    />,
    <GroupHistoryAction
      key="GroupHistoryAction"
      variant={variant}
      group={group}
    />,
    <GroupRecipesAction
      key="GroupRecipesAction"
      variant={variant}
      group={group}
    />,
    <GroupCamerasAction
      key="GroupCamerasAction"
      variant={variant}
      group={group}
    />,
    <GroupReportAction
      key="GroupReportAction"
      variant={variant}
      group={group}
    />,
    <GroupAlarmsAction
      key="GroupAlarmsAction"
      variant={variant}
      group={group}
    />,
    <GroupComposableDeviceAction
      group={group}
      variant={variant}
      key="GroupComposableDeviceAction"
    />,
    <GroupComposableDashboardAction
      group={group}
      variant={variant}
      key="GroupComposableDashboardAction"
    />,
  ];

  return isMobile ? (
    <DefaultMenuButtons buttons={menuButtons} />
  ) : (
    <Box
      sx={{
        flexGrow: 1,
        display: 'flex',
        justifyContent: 'flex-end',
        alignContent: 'center',
        fontSize: '1.6em',
        color: (theme) => theme.typography.body1.color,
      }}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      {menuButtons.map((button) => button)}
    </Box>
  );
}
